import { render, staticRenderFns } from "./MakeRoll.vue?vue&type=template&id=694c741c"
import script from "./MakeRoll.vue?vue&type=script&lang=js"
export * from "./MakeRoll.vue?vue&type=script&lang=js"
import style0 from "./MakeRoll.vue?vue&type=style&index=0&id=694c741c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports